document.querySelectorAll("[data-tea-discovery-url]").forEach(function (section) {
  var url = section.getAttribute("data-tea-discovery-url");
  if (!url) return;
  fetch(url)
    .then(function (response) { return response.text(); })
    .then(function (html) {
      var parsed = document.createElement("div");
      parsed.innerHTML = html;
      var next = parsed.querySelector("[data-tea-discovery]");
      var current = section.querySelector("[data-tea-discovery]");
      if (next && current && next.innerHTML.trim()) current.innerHTML = next.innerHTML;
    })
    .catch(function () {});
});
